import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';

import { BlankComponent} from './blank.component';
import { BasicComponent } from './basic.component';
import {AnonymousComponent} from './anonymous.component';

import {NavigationModule} from '../navigation/navigation.module';
import {TopNavBarModule} from '../topnavbar/topnavbar.module';
import { FooterModule } from '../footer/footer.module';

import { SimpleNotificationsModule } from 'angular2-notifications';
import { BlockUIModule } from 'ng-block-ui';

@NgModule({
    declarations: [BlankComponent, BasicComponent, AnonymousComponent],
    imports: [BrowserModule, RouterModule, NavigationModule, TopNavBarModule, FooterModule, SimpleNotificationsModule, BlockUIModule],
    exports: [BlankComponent, BasicComponent, AnonymousComponent]
})

export class LayoutsModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/layouts/layouts.module.ts